<template>
    <b-container class="d-flex flex-column" fluid>
        <b-row class="my-3 flex-shrink-0" align-h="center" align-v="start">
            <b-col md="4" sm="12">
                <router-view name="nav"/>
            </b-col>
        </b-row>

        <b-row class="border-top-radius elevation-1 flex-grow-1 overflow-auto" align-h="center">
            <b-col md="4" sm="12">
                <transition name="fade" mode="out-in">
                    <router-view/>
                </transition>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: "TopNavLayout",
    }
</script>

<style scoped>

</style>
